module.exports = __webpack_public_path__ + "img/poc_sketch.1d27ab41.png";